import { select, on } from './utility';
import datepicker from './nid/datepicker';

Date.prototype.yyyymmdd = function () {
    let mm = this.getMonth() + 1; // getMonth() is zero-based
    let dd = this.getDate();

    return [this.getFullYear(),
    (mm > 9 ? '' : '0') + mm,
    (dd > 9 ? '' : '0') + dd
    ].join('-');
};

document.addEventListener('DOMContentLoaded', function () {

    on('click', '[data-action="quantity"]', function (e) {
        e.preventDefault();

        let parentNode = this.parentNode,
            input = parentNode.getElementsByTagName('input')[0],
            min = parseInt(input.getAttribute('min')),
            max = parseInt(input.getAttribute('max')),
            step = parseInt(input.getAttribute('step')),
            value = parseInt(input.value);

        let operation = this.getAttribute('data-value');

        if (min < 1) {
            min = 1;
        }

        if (isNaN(value)) {
            value = 1;
        }
        if (isNaN(step)) {
            step = 1;
        }

        if (operation == 'increase') {
            value = value + step;
        } else if (operation == 'decrease') {
            value = value - step;
        }

        if (!isNaN(min) && value < min) {
            value = min;
        }
        if (!isNaN(max) && value > max) {
            value = max;
        }

        input.value = value;

        jQuery(input).trigger('change');
    });

    on('click', 'a.showlogin', function (e) {
        e.preventDefault();

        jQuery('.woocommerce-form-login').toggle();
    });

    const datePickerInputs = select('.date-picker');

    datePickerInputs.forEach(function (datePickerInput) {
        datepicker(datePickerInput, {
            customDays: nordsjo.tWeekDays,
            customMonths: nordsjo.tMonths,
            minDate: new Date(),
            disableYearOverlay: true,
            formatter: (input, date, instance) => {
                input.value = date.yyyymmdd();
            }
        });
    });

});